
import { Component, Vue } from 'vue-property-decorator'
import { defaultDescription } from '@/seo'

@Component({
  seo: {
    title: 'Aaron Cunliffe',
    description: defaultDescription
  },
  components: {
  }
})
export default class Home extends Vue {}
